import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    getActiveList,
    getActivityData,
    getCanViewStats,
    getFinishedList,
    getIsLoading,
    getParticipants,
    getParticipantStats,
    getSpecificTrainingData,
    getTrainingStats,
} from "../selectors";
import {
    downloadMyTrainingCertificatesAction,
    getActivityFromSpecificTrainingAction,
    getAllMyTrainingAction,
    getMyTrainingStatsAction,
    getSpecificTrainingAction,
    getSpecificTrainingProgressAction,
} from "../actions";
import { RESET_ALL, RESET_SPECIFIC_TRAINING } from "../actionTypes";

const useMyTraining = () => {

    const [participantsDialogIsOpen, setParticipantsDialogIsOpen] = useState(false);
    const [selectedTrainingId, setSelectedTrainingId] = useState(null);
    const [statsPageIsOpen, setStatsPageIsOpen] = useState(false);

    const dispatch = useDispatch();
    const isLoading = useSelector(getIsLoading);
    const activeList = useSelector(getActiveList);
    const finishedList = useSelector(getFinishedList);
    const canViewStats = useSelector(getCanViewStats);
    const participants = useSelector(getParticipants);
    const specificTrainingData = useSelector(getSpecificTrainingData);
    const activityData = useSelector(getActivityData);
    const trainingStats = useSelector(getTrainingStats);
    const participantStats = useSelector(getParticipantStats);

    useEffect(() => {
        dispatch(getAllMyTrainingAction());

        return () => {
            dispatch({ type: RESET_ALL });
        }
    }, [dispatch])

    const handleDownloadCertificates = (trainingId) => {
        dispatch(downloadMyTrainingCertificatesAction(trainingId));
    }

    const handleOpenStatsPage = () => {
        dispatch(getMyTrainingStatsAction())
            .then((resp) => {
                if (resp.status === 200) {
                    setStatsPageIsOpen(true);
                }
            })
    }

    const handleCloseStatsPage = () => {
        setStatsPageIsOpen(false);
    }

    const handleOpenTrainingExecution = (trainingId) => {
        dispatch(getSpecificTrainingAction(trainingId))
            .then((resp) => {
                if (resp.status === 200) {
                    dispatch(getActivityFromSpecificTrainingAction(trainingId, resp.data.currentActivityId))
                        .then((resp) => {
                            if (resp.status === 200) {
                                window.scrollTo(0, 0);
                                setSelectedTrainingId(trainingId);
                            }
                        })
                }
            })
    }

    const handleCloseTrainingExecution = () => {
        dispatch(getAllMyTrainingAction())
            .then(() => {
                window.scrollTo(0, 0);
                setSelectedTrainingId(null);
                dispatch({ type: RESET_SPECIFIC_TRAINING })
            })
    }

    const handleOpenParticipantsDialog = (trainingId) => {
        dispatch(getSpecificTrainingProgressAction(trainingId))
            .then((resp) => {
                if (resp.status === 200) {
                    setParticipantsDialogIsOpen(true);
                }
            })
    }

    const handleCloseParticipantsDialog = () => {
        setParticipantsDialogIsOpen(false);
    }

    const state = {
        selectedTrainingId,
        participantsDialogIsOpen,
        statsPageIsOpen,
    }

    const handlers = {
        handleDownloadCertificates,
        handleOpenTrainingExecution,
        handleCloseTrainingExecution,
        handleOpenParticipantsDialog,
        handleCloseParticipantsDialog,
        handleOpenStatsPage,
        handleCloseStatsPage,
    }

    return {
        isLoading,
        activeList,
        finishedList,
        canViewStats,
        participants,
        specificTrainingData,
        activityData,
        trainingStats,
        participantStats,
        state,
        handlers,
    }
}

export default useMyTraining;